export default __webpack_public_path__ + "images/arbeth_433cc8.svg";